import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  videoUrl: "视频路径",
  dialogPlay: "是否弹框播放",
  loopPlay: "是否循环播放",
  autoplayStatus: "是否自动播放",
  controlStatus: "显示控制条",
  updateTimer: "数据轮询时间",
  restDataUrl: "外接数据源地址",
  borderStyle: "边框类型", // solid dashed dotted
  borderColor: "边框颜色",
  borderWidth: "边框宽度",
  bgColor: "播放按钮背景颜色",
  iconBorderStyle: "播放按钮边框类型",
  iconBorderColor: "播放按钮边框颜色",
  iconBorderWidth: "播放按钮边框宽度",
  iconColor: "播放按钮颜色",
  iconWidth: "播放按钮大小",
  uploadVideoImg: "视频封面",
  videoPaddingTop: "上边距",
  videoPaddingRight: "右边距",
  videoPaddingLeft: "左边距",
  videoPaddingBottom: "下边距",
  borderTopLeftRadius: "边框左上角圆角",
  borderTopRightRadius: "边框右上角圆角",
  borderBottomLeftRadius: "边框左下角圆角",
  borderBottomRightRadius: "边框右下角圆角",
  boxShadowColor: "边框阴影颜色",
  boxShadowH: "阴影x轴的偏移量",
  boxShadowV: "阴影y轴的偏移量",
  boxShadowBlur: "阴影模糊值",
  boxShadowSpread: "阴影扩散值"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
